import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-2 flex items-center space-x-2 space-y-2 py-2" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-2 pt-4" }
const _hoisted_3 = ["checked"]

import { computed, reactive, watch } from 'vue';
import { useVuelidateWithLogging } from '@/composables/useVuelidateWithLogging';
import { TrashIcon } from '@heroicons/vue/solid';

import { isValidPhone, required, maxLength, uniquePhone } from '@/utils/validators';
import { ContactPhoneFormState } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactPhoneForm',
  props: {
    modelValue: {
        type: Object as () => ContactPhoneFormState,
        required: true,
    },
    index: {
        type: Number,
        required: true,
    },
    canRemove: {
        type: Boolean,
        default: true,
    },
    phones: {
        type: Array as () => ContactPhoneFormState[],
        required: true,
    },
},
  emits: ['update:modelValue', 'remove', 'set-main'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const formState = reactive<ContactPhoneFormState>(props.modelValue);

const rules = computed(() => ({
    number: {
        isValidPhone,
        required,
        maxLength: maxLength(50),
        uniquePhone: uniquePhone(props.phones, props.index),
        _key: {},
    },
    isMain: { required },
}));

const { v$, $validateWithLogging } = useVuelidateWithLogging(rules, formState);

__expose({
    validate: () => $validateWithLogging(),
});

watch(
    formState,
    () => {
        emit('update:modelValue', formState);
    },
    {
        deep: true,
    },
);

return (_ctx: any,_cache: any) => {
  const _component_UiTextInput = _resolveComponent("UiTextInput")!
  const _component_UiActionButton = _resolveComponent("UiActionButton")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiTextInput, {
      modelValue: _unref(v$).number.$model,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).number.$model) = $event)),
      name: "number",
      type: "text",
      label: _ctx.$t('contact.form.labels.phone'),
      class: "flex-1",
      errors: _unref(v$).number.$errors,
      onBlur: _unref(v$).number.$touch
    }, null, 8, ["modelValue", "label", "errors", "onBlur"]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "radio",
        checked: formState.isMain,
        class: "text-primary focus:ring-primary mt-0.5",
        onChange: _cache[1] || (_cache[1] = ($event: any) => (emit('set-main')))
      }, null, 40, _hoisted_3), [
        [_directive_tippy, _ctx.$t('contact.form.actions.setMainPhone')]
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
        variant: "danger",
        class: _normalizeClass(["", { 'cursor-not-allowed opacity-40': !__props.canRemove }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('remove', __props.index)))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
        ]),
        _: 1
      }, 8, ["class"])), [
        [_directive_tippy, 
                    __props.canRemove
                        ? _ctx.$t('contact.form.actions.removePhone')
                        : _ctx.$t('contact.form.actions.cannotRemovePhone')
                ]
      ])
    ])
  ]))
}
}

})